import { put, takeLatest } from "redux-saga/effects";
import { types } from "../action_types";
import { POST } from "../../Utils/httpServices";
import CustomToster from "../../SharedComponents/CustomToaster";

function* SignInSaga({ payload }) {
  const { authData, history } = payload;

  try {
    const signin_response = yield POST("admin/auth/login", authData);
    
    // Development mode: Skip OTP if devMode is true
    if (signin_response?.data?.data?.devMode || signin_response?.data?.devMode) {
      const token = signin_response?.data?.data?.token || signin_response?.data?.token;
      if (token) {
        window.sessionStorage.setItem("token", token);
        window.sessionStorage.setItem("showSidebar", "true");
        CustomToster({ type: "success", message: "Development mode: Logged in successfully" });
        history("/dashboard");
        // Don't reload to avoid redirect loop
        return;
      }
    }

    if (authData.email === "demo@gmail.com") {
      window.sessionStorage.setItem(
        "token",
        signin_response?.data?.data?.token || signin_response?.data?.data?.authToken
      );
      window.sessionStorage.setItem("showSidebar", "true");
      window.location.href = "/dashboard";
      return;
    }

    let responsedata = { ...signin_response?.data };

    if (signin_response?.status === 200) {
      // Check if we have a token directly (dev mode or production without OTP)
      const token = responsedata?.result?.token || responsedata?.result?.authToken || responsedata?.data?.token || responsedata?.data?.authToken || responsedata?.token;

      if (token && !responsedata?.data?.requiresOtp) {
        // If we have a token and OTP is not required, login directly
        window.sessionStorage.setItem("token", token);
        window.sessionStorage.setItem("showSidebar", "true");
        CustomToster({ type: "success", message: responsedata?.data?.message || "Login successful" });
        history("/dashboard");
        return;
      }

      // Otherwise, proceed to OTP screen
      yield put({
        type: types.SignInRequestSuccess,
        payload: responsedata,
      });

      CustomToster({ type: "success", message: responsedata?.data?.message || "Login successful" });
      history("/otp");
    } else {
      yield put({ type: types.SignInRequestFailure });
    }
  } catch (e) {
    // Log error for debugging
    console.error('Login error:', e);
    console.error('Error response:', e?.response?.data);
    
    // Ensure message is a string, not an object
    let errorMessage = 'Login failed';
    
    // Check various error response formats
    if (e?.response?.data?.error?.message) {
      errorMessage = typeof e.response.data.error.message === 'string' 
        ? e.response.data.error.message 
        : String(e.response.data.error.message);
    } else if (e?.response?.data?.message) {
      errorMessage = typeof e.response.data.message === 'string'
        ? e.response.data.message
        : String(e.response.data.message);
    } else if (e?.message) {
      errorMessage = typeof e.message === 'string' ? e.message : String(e.message);
    } else if (e?.response?.status === 401) {
      errorMessage = 'Invalid email or password';
    } else if (e?.response?.status === 500) {
      errorMessage = 'Server error. Please try again later.';
    } else if (!e?.response) {
      errorMessage = 'Network error. Please check if the server is running on http://localhost:3001';
    }
    
    CustomToster({
      type: "error",
      message: errorMessage,
    });

    yield put({ type: types.SignInRequestFailure });
  }
}

// Its for sending email to user that can click and reset password
function* EmailForOTPCreateNewPasswordSaga({ payload }) {
  const { createNewpassEmailSend, history } = payload;

  try {
    const email_for_otp_create_new_password_response = yield POST(
      "admin/auth/forget-password",
      createNewpassEmailSend
    );

    if (email_for_otp_create_new_password_response?.status === 200) {
      yield put({
        type: types.EmailForOtpCreateNewPasswordRequestSuccess,
        payload: createNewpassEmailSend.email,
      });

      CustomToster({
        type: "success",
        message: "OTP sent to the email.Please use that to reset the password.",
      });
      history("/create-new-password");
    } else {
      yield put({ type: types.EmailForOtpCreateNewPasswordRequestFailure });
    }
  } catch (e) {
      // Ensure message is a string
      const apiMessage = e?.response?.data?.message || e?.response?.data?.error?.message;
      const errorMessage = typeof apiMessage === 'string'
        ? apiMessage
        : (typeof e?.message === 'string' ? e.message : String(e?.message || 'Request failed'));
      
      CustomToster({
        type: "error",
        message: errorMessage,
      });
    yield put({ type: types.EmailForOtpCreateNewPasswordRequestFailure });
  }
}
// After clicking link screen open and change password and new password would be send by this
function* CreateNewPasswordSaga({ payload }) {
  const { forgetUserPasowrdData, history } = payload;
  try {
    const email_for_otp_create_new_password_response = yield POST(
      "admin/auth/restore-password",
      forgetUserPasowrdData
    );

    let responsedata = {
      ...email_for_otp_create_new_password_response?.responsedata,
      token: payload,
    };

    if (email_for_otp_create_new_password_response?.status === 200) {
      yield put({
        type: types.EmailForOtpCreateNewPasswordRequestSuccess,
        payload: responsedata,
      });
      CustomToster({ type: "success", message: responsedata?.data?.message });
      history("/");
    } else {
      yield put({ type: types.EmailForOtpCreateNewPasswordRequestFailure });
    }
  } catch (e) {
      // Ensure message is a string
      const apiMessage = e?.response?.data?.message || e?.response?.data?.error?.message;
      const errorMessage = typeof apiMessage === 'string'
        ? apiMessage
        : (typeof e?.message === 'string' ? e.message : String(e?.message || 'Request failed'));
      
      CustomToster({
        type: "error",
        message: errorMessage,
      });
    yield put({ type: types.EmailForOtpCreateNewPasswordRequestFailure });
  }
}

export default function* AuthSaga() {
  yield takeLatest(types.SignInRequest, SignInSaga);

  yield takeLatest(
    types.EmailForOtpCreateNewPasswordRequest,
    EmailForOTPCreateNewPasswordSaga
  );
  yield takeLatest(types.CreateNewPasswordRequest, CreateNewPasswordSaga);
}
